<div class="wirecount-container">
  <p class="key-text">{{ wireCountKeyText[formType] }}</p>
  <h4 class="headtext margin_btm" id="table-header">
    {{ title }}
  </h4>
  <table
    class="wire-count-table"
    id="dwc_{{ tSCount }}_{{ wcCount }}_{{ wct }}"
    [ngClass]="{
      'form-16': formType === wireCountTypes.form16,
      'form-18': formType === wireCountTypes.form18,
      'form-19': formType === wireCountTypes.form19
    }"
    aria-labelledby="table-header"
  >
    <tr
      *ngFor="let row of wireData; let i = index"
      id="wcDetails_{{ tSCount }}_{{ wcCount }}_{{ wct }}_{{ i }}"
      class="slipDetailsWC_{{ tSCount }}_{{ wcCount }}_{{ wct }}"
    >
      <td
        [attr.colspan]="cell.Colspan > 0 ? cell.Colspan : 1"
        [attr.rowspan]="cell.Rowspan > 0 ? cell.Rowspan : 1"
        [ngClass]="cell.ClassName ? cell.ClassName : ''"
        *ngFor="let cell of row; let j = index"
      >
        <div
          class="wire-count-input"
          [ngClass]="cell.Validated ? cell.Validated : ''"
        >
          {{ cell.Value }}
        </div>
      </td>
    </tr>
  </table>
</div>
